import React from "react";
import {
  Select as MUISelect,
  SelectProps,
  InputAdornment,
  IconButton,
  styled,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";

type Props = SelectProps & {
  width?: string;
  hasClearButton?: boolean;
  onClear?: any;
};

const TheSelect = ({
  hasClearButton = true,
  onClear,
  ...otherProps
}: Props) => (
  <MUISelect
    {...otherProps}
    endAdornment={
      otherProps.value !== "" &&
      hasClearButton &&
      !otherProps.disabled && (
        <InputAdornment position="end">
          <IconButton
            data-test-id={`clear-${otherProps.id}`}
            size="small"
            onClick={onClear}
          >
            <Cancel />
          </IconButton>
        </InputAdornment>
      )
    }
  />
);

const Select = styled(TheSelect)<Props>`
  border: ${(props) => props.theme.palette.primary.main};
  width: ${(props) => props.width || "400px"};
  background-color: ${(props) =>
    props.disabled ? props.theme.palette.grey[100] : "inherit"};
  .MuiSelect-icon {
    color: ${(props) =>
      props.disabled
        ? props.theme.palette.grey[100]
        : props.theme.palette.primary.main};
  }
  .MuiIconButton-root {
    outline: 0;
    color: ${(props) => props.theme.palette.grey[300]};
  }
  .MuiInputAdornment-root {
    padding-right: 15px;
  }
`;

export default Select;
